<template>
  <v-layout row justify-center>
    <v-dialog v-model="showEditUser" max-width="700px"
      transition="dialog-bottom-transition" @keydown.esc="showEditUser = false">
      <v-card v-if="user && user._id">
        <v-toolbar color="blue-grey lighten-5">
          <v-spacer></v-spacer>
          <v-toolbar-title class="text-xs-center">
            Editar conta
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="showEditUser = false">
            <v-icon>fal fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 md6>
              <v-text-field label="Nome" v-model="user.first_name" required></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field label="Sobrenome" v-model="user.last_name" required></v-text-field>
            </v-flex>

            <v-flex xs12 md4>
              <v-menu ref="birthDatePicker" :close-on-content-click="false"
                v-model="birthDatePicker" :nudge-right="40" lazy transition="scale-transition"
                offset-y full-width max-width="290px" min-width="290px">
                <v-text-field slot="activator" v-model="dateFormatted" label="Data de nascimento"
                  hint="DD/MM/AAAA" persistent-hint @blur="date = parseDate(dateFormatted)"></v-text-field>
                <v-date-picker locale="pt-br" v-model="date" no-title
                  @input="birthDatePicker = false" prev-icon="fal fa-angle-left"
                  next-icon="fal fa-angle-right"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 md4>
              <v-select :items="gender" item-text="name" item-value="value" v-model="user.gender"
                append-icon="fal fa-chevron-down" label="Gênero" single-line required></v-select>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field label="Estatura (cm)" mask="###" :hint="user.stature ? user.stature + 'cm' : ''"
                v-model="user.stature" required></v-text-field>
            </v-flex>

            <v-flex xs12 md6>
              <v-text-field label="RG" v-model="user.document" required></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field label="CPF" mask="###.###.###-##" v-model="user.document_number" required></v-text-field>
            </v-flex>

            <v-flex xs12 md6>
              <v-text-field label="Telefone" v-model="user.phones[0]"
                mask="(##) #####-####" return-masked-value required></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field label="CEP" v-model="address.zip"
                mask="#####-####" required></v-text-field>
            </v-flex>

            <v-flex xs12 md6>
              <v-autocomplete :items="states" v-model="address.state"
                append-icon="fal fa-chevron-down" label="Estado" single-line required></v-autocomplete>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field label="Cidade" v-model="address.city" required></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-text-field label="Rua" v-model="address.street" required></v-text-field>
            </v-flex>

            <v-flex xs12 md6>
              <v-text-field label="Bairro" v-model="address.neighborhood" required></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field label="Complemento" v-model="address.complement"></v-text-field>
            </v-flex>
          </v-layout>

          <p class="text-xs-right">
            <v-btn round large depressed color="success" :loading="loadingRequest"
              @click.stop="save()">
              Salvar
            </v-btn>
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import EventBus from '@/event-bus'
// import router from '@/router'
import axios from 'axios'

export default {
  name: 'Account',
  data: () => ({
    user: {
      phones: []
    },
    showEditUser: false,
    loadingRequest: false,
    isNewAddress: true,
    date: null,
    dateFormatted: null,
    birthDatePicker: false,
    address: {},
    states: ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RO', 'RS', 'RR', 'SC', 'SE', 'SP', 'TO'],
    gender: [
      { name: 'Masculino', value: 'male' },
      { name: 'Feminino', value: 'female' }
    ]
  }),

  methods: {
    loadAddress () {
      // eslint-disable-next-line
      axios.get(`${API.userAddresses}/users/${this.user._id}`).then(response => {
        if (response.data.addresses && response.data.addresses[0]) {
          this.address = response.data.addresses[0]
          this.isNewAddress = false
        } else {
          this.address = {}
          this.isNewAddress = true
        }
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: 'Ocorreu um erro ao carregar o endereço', color: 'error' })
      })
    },

    loadUser () {
      this.loadingRequest = true
      if (!this.user.phones) this.user.phones = []

      // eslint-disable-next-line
      axios.get(`${API.users}/${this.$route.params.id}`).then(response => {
        this.user = response.data.user
        this.loadingRequest = false
        if (this.user.birthday) this.date = this.user.birthday.replace('T00:00:00.000Z', '')
        this.loadAddress()
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: 'Ocorreu um erro carregar o usuário', color: 'error' })
      })
    },

    validateAddress (address) {
      return address && (address.street || address.zip || address.city || address.state)
    },

    saveAddress () {
      this.loadingRequest = true
      let request

      if (!this.validateAddress(this.address)) return

      if (this.isNewAddress) {
        // eslint-disable-next-line
        request = axios.post(`${API.userAddresses}/users/${this.user._id}`, this.address)
      } else {
        // eslint-disable-next-line
        request = axios.put(`${API.userAddresses}/${this.address._id}`, this.address)
      }

      request.then(response => {
        this.loadingRequest = false
      }).catch(errors => {
        this.loadingRequest = false
        EventBus.$emit('showSnackbar', {
          message: 'Preencha todos os campos corretamente',
          color: 'error'
        })
      })
    },

    save () {
      this.loadingRequest = true

      if (this.date) this.user.birthday = this.date
      if (this.address) this.saveAddress()

      // eslint-disable-next-line
      axios.put(`${API.users}/${this.user._id}`, this.user).then(response => {
        this.loadingRequest = false
        this.showEditUser = false
        EventBus.$emit('loadUser')
        EventBus.$emit('showSnackbar', { message: 'Alterações salvas com sucesso!', color: 'success' })
        EventBus.$on('loadUserOnMP')
      }).catch(errors => {
        this.loadingRequest = false
        EventBus.$emit('showSnackbar', {
          message: 'Ocorreu um erro ao salvar o perfil',
          color: 'error'
        })
      })
    },

    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
  },

  watch: {
    date (val) {
      this.dateFormatted = this.formatDate(this.date)
    }
  },

  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    }
  },

  beforeDestroy () {
    EventBus.$off('showEditUser')
  },

  mounted () {
    EventBus.$on('showEditUser', data => {
      this.showEditUser = data
      this.loadUser()
    })
  }
}
</script>

<style scoped>
.flex {
  padding: 0 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/userShow/AdminUserShowEdit.vue